import { AppEntities } from "../../../../config/entities";
import { IListViewField } from "../../../Shared/ILIstViewField";
import { NewDocumentListView } from "../../../Shared/NewDocumentListView";

const EmployeeHiresList = () => {
    const fields: IListViewField[] = [
    ];

    return (
        <>
            <NewDocumentListView fields={fields} entity={AppEntities.EmployeeHires} />
        </>
    );
}

export default EmployeeHiresList;